import { useEffect, useRef } from "react";

const logos = [
  { name: "Подорожник", img: "https://storage.readdy-site.link/project_files/7cf81fbf-fb7d-4618-bb94-f6f654527b2e/cabfdc52-3b5d-4784-b45f-510fb79eea4c______.png?v=3ab8e3b63f20c6d11aa067eb57a0dc93", width: "200px", height: "80px", mdWidth: "260px", mdHeight: "104px" },
  { name: "Рошен", img: "https://storage.readdy-site.link/project_files/7cf81fbf-fb7d-4618-bb94-f6f654527b2e/7e2de25a-3cd9-488d-b1a9-9a3689583d1a_Roshen_Logo.png?v=e494a96101d874d5cd09a8470a86a234" },
  { name: "Аврора", img: "https://storage.readdy-site.link/project_files/7cf81fbf-fb7d-4618-bb94-f6f654527b2e/d3373b5b-0ef9-4f5a-bb02-754428a5a872_logo-1631102713-1.png?v=23632215f089d2d264b82086c6f04aad" },
  { name: "Moyo", img: "https://storage.readdy-site.link/project_files/7cf81fbf-fb7d-4618-bb94-f6f654527b2e/2ff572a4-e2d3-4309-b732-60b4dfdc9f0f_LOGO_moyo_1.png?v=1b8179a7f59a7d9844d4d59c44222013", width: "160px", height: "64px", mdWidth: "200px", mdHeight: "80px" },
  { name: "ЦУМ", img: "https://storage.readdy-site.link/project_files/7cf81fbf-fb7d-4618-bb94-f6f654527b2e/a036a222-6581-440a-a47c-650892988d48_unnamed.png?v=b1274169fc02644af9238ae74c0b2779" },
  { name: "911", img: "https://storage.readdy-site.link/project_files/7cf81fbf-fb7d-4618-bb94-f6f654527b2e/5366da6c-9b77-4bfb-a5b6-ab455c01a1b7_9f3ba0_64d6e9876597498189a30b6517cd5446mv2-1.png?v=52f0e7b5ec2781e7647698d144145a03", width: "160px", height: "64px", mdWidth: "200px", mdHeight: "80px" },
  { name: "Червоний маркет", img: "https://storage.readdy-site.link/project_files/7cf81fbf-fb7d-4618-bb94-f6f654527b2e/c3fbd0bb-6124-4d8f-916b-e73a8fc14812_-.png?v=bdfe64cd6ce7dd3986d8b1734ffc64fe", width: "160px", height: "64px", mdWidth: "200px", mdHeight: "80px" },
  { name: "ТехноЇжак", img: "https://storage.readdy-site.link/project_files/7cf81fbf-fb7d-4618-bb94-f6f654527b2e/a1c8a4f4-b66e-47ba-bef6-944bb2cdc687_unnamed.png?v=abbdb69f6e98aafda28189d904fe36e9" },
  { name: "Віяр", img: "https://storage.readdy-site.link/project_files/7cf81fbf-fb7d-4618-bb94-f6f654527b2e/dd9833e2-be46-40b1-a9d3-6c3200c548fa_Logo-Viyar-syno-zhovte-rgb.png?v=c11aa0374ba6f6a6ae92a44e7d05ea6b" },
  { name: "Sova", img: "https://storage.readdy-site.link/project_files/7cf81fbf-fb7d-4618-bb94-f6f654527b2e/ae166026-da6e-4ec6-b991-07b98d079751_sova.png?v=38931fc0eca3b300b9d34eac89d6b630" },
  { name: "Gunia Project", img: "https://storage.readdy-site.link/project_files/7cf81fbf-fb7d-4618-bb94-f6f654527b2e/6493ee68-b97c-4ebf-a11d-feb07d086675_Gunia_Project_logo.png?v=4cfb6b21b630fdc1c3c2161c2130996b" },
];

const LogoSet = () => (
  <>
    {logos.map((logo, i) => (
      <div
        key={i}
        className="flex flex-col items-center gap-2.5 flex-shrink-0 px-8 md:px-12"
      >
        <div
          className={`flex items-center justify-center ${
            logo.width
              ? "w-[180px] md:w-[220px] h-[70px] md:h-[86px]"
              : "w-[120px] md:w-[140px] h-[48px] md:h-[56px]"
          }`}
        >
          <img
            src={logo.img}
            alt={logo.name}
            className="w-full h-full object-contain opacity-80 hover:opacity-100 transition-opacity duration-300"
          />
        </div>
      </div>
    ))}
  </>
);

export default function Hero() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const children = section.querySelectorAll(".hero-animate");
    children.forEach((child, i) => {
      setTimeout(() => {
        child.classList.add("visible");
      }, i * 200);
    });
  }, []);

  const scrollToCta = () => {
    const el = document.querySelector("#cta");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      ref={sectionRef}
      className="relative min-h-screen flex flex-col items-center justify-center pt-24 md:pt-28 pb-20 overflow-hidden bg-white"
    >
      <div className="relative z-10 max-w-[1024px] mx-auto w-full text-center px-6">
        <h1 className="hero-animate animate-on-scroll text-[40px] sm:text-[50px] lg:text-[60px] font-semibold leading-[1.1] tracking-tight mb-6">
          <span className="text-[#1d1d1f]">Ідеальний найм<br />для ритейлу:</span>
          <br />
          <span className="gradient-text-shimmer">у 3 рази швидше,<br />AI-скринінг<br /></span>
        </h1>

        <p className="hero-animate animate-on-scroll text-[17px] sm:text-[19px] lg:text-[21px] text-[#86868b] leading-relaxed max-w-[720px] mx-auto mb-3 font-medium">
          <strong>HURMA – рекрутинг-система для торгових мереж.</strong> Збирає всіх кандидатів з усіх локацій і джоб-порталів в одну систему, прискорює відгук і дає аналітику найму.
        </p>

        <p className="hero-animate animate-on-scroll text-[17px] sm:text-[19px] lg:text-[21px] gradient-text-shimmer font-bold leading-relaxed max-w-[720px] mx-auto mb-10">
          Для мереж АЗС, аптек, FMCG, HoReCa, які наймають масово і постійно.
        </p>

        <div className="hero-animate animate-on-scroll flex justify-center">
          <a
            href="https://hurma.work/request-2/?utm_source=retail_landing&utm_medium=demo&utm_campaign=2026"
            target="_blank"
            rel="noopener noreferrer"
            className="gradient-bg text-white text-[13px] sm:text-[14px] font-bold px-5 sm:px-7 py-2.5 sm:py-3 rounded-full hover:opacity-90 transition-opacity inline-flex items-center whitespace-nowrap"
          >
            Замовити демо
            <i className="ri-arrow-right-line ml-1.5 text-sm" />
          </a>
        </div>
      </div>

      {/* Logo marquee — full width */}
      <div className="hero-animate animate-on-scroll w-full overflow-hidden mt-12 mb-12">
        <div className="marquee-track flex items-center">
          <LogoSet />
          <LogoSet />
          <LogoSet />
        </div>
      </div>

      <div className="relative z-10 max-w-[1024px] mx-auto w-full text-center px-6">
        <div className="hero-animate animate-on-scroll">
          <div className="relative mx-auto max-w-[900px]">
            <div className="absolute -inset-4 bg-gradient-to-r from-gray-300/20 to-gray-400/15 rounded-[32px] blur-2xl" />
            <div className="relative rounded-[24px] overflow-hidden bg-[#1a1a2e] shadow-2xl">
              <div className="flex items-center gap-2 px-4 py-3 bg-[#16162a] border-b border-white/[0.08]">
                <span className="w-2.5 h-2.5 rounded-full bg-red-400/80" />
                <span className="w-2.5 h-2.5 rounded-full bg-yellow-400/80" />
                <span className="w-2.5 h-2.5 rounded-full bg-green-400/80" />
                <div className="ml-3 flex items-center gap-2 bg-white/10 rounded-md px-3 py-1">
                  <span className="text-white/40 text-[11px] font-mono">hurma.work</span>
                </div>
              </div>
              <div style={{ position: 'relative', aspectRatio: '16/9' }}>
                <iframe
                  loading="lazy"
                  title="Gumlet video player"
                  src="https://play.gumlet.io/embed/6a1fdb4a1bfeba299d03f927?background=false&autoplay=true&loop=true&disable_player_controls=false"
                  style={{ border: 'none', position: 'absolute', top: 0, left: 0, height: '100%', width: '100%' }}
                  referrerPolicy="origin"
                  allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen; clipboard-write"
                />
              </div>
            </div>
          </div>
        </div>
      </div>


    </section>
  );
}